module.exports = __webpack_public_path__ + "static/media/linkedin-1.4b475fb3.svg";